import {QuestionCircleOutlined} from '@ant-design/icons';
import {Tooltip} from 'antd';
import Form, {FormItemProps} from 'antd/es/form';
import Input from 'antd/es/input';
import React, {FC} from 'react';

import {isNumberRegExp, widthRegExp} from 'shared/regular-expressions';
import {IFormItemProps as AntFormItemProps} from 'shared/types';

type TFormItemWidthInputProps = FormItemProps;
type TWidthInputProps = AntFormItemProps;

const WidthInput: FC<TWidthInputProps> = ({
    onChange,
    value,
}: TWidthInputProps) => (
    <Input
        value={value}
        placeholder="Введите значение"
        onChange={e => onChange?.(e.target.value, undefined)}
        onBlur={e => {
            const {value: v} = e.target;
            if (isNumberRegExp.test(v)) {
                onChange?.(`${v}px`, undefined);
            }
        }}
    />
);

export const FormItemWidthInput: FC<TFormItemWidthInputProps> = (
    props: TFormItemWidthInputProps,
) => (
    <Form.Item
        label={(
            <span
                className="d-inline-flex align-items-center"
                style={{gap: 6}}
            >
                Ширина столбца
                <Tooltip
                    title={'Доступные единицы: px, vw (от ширины экрана), cm, mm (например, "100px")'}
                    placement="right"
                >
                    <QuestionCircleOutlined style={{
                        color: '#B7C1D5',
                    }}
                    />
                </Tooltip>
            </span>

        )}
        {...props}
        rules={[{
            validator: (_, value) => {
                if (!value || widthRegExp.test(value)) return Promise.resolve();
                return Promise.reject(new Error('Некорректное значение ширины'));
            },
        }, {}]}
    >
        <WidthInput />
    </Form.Item>
);
